var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V24H3V19H4V23H20V7H14V1H4V14H3V0H15L21 6ZM15 6H19.5L15 1.5V6Z",
    fill: "#040404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14C2 13.4477 2.44772 13 3 13H21C21.5523 13 22 13.4477 22 14V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V14Z",
    fill: "#4CB050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5L10 15H11V20H10V17L9 19H8L7 17V20H6L6.0127 15H7L8.5 17.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15C16.4303 15.0048 17.0035 16.1297 17 17.5C16.9964 18.879 16.4374 19.9998 15 19.9951L13 19.9922L13.0127 15H15ZM14 19L15 19.0117C15.9918 19.015 16 18.1328 16 17.5C16 17.0003 15.9692 16.0033 15 16H14V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.16aac1f612407ad60510a3a0b6d2af9c.svg";
export { ForwardRef as ReactComponent };